import NotificationsList from '../../components/Notifications/NotificationsList';
import { Stack } from '@presov.sk/presov-ui-react';
import React from 'react';
import { useSearchParams } from 'react-router';

/** Nadpis sekcie tu nie je - je to titul stránky ([[ProfilePage]]). */
const NotificationHistory: React.FC = () => {
  const [searchParams] = useSearchParams();

  return (
    <Stack gap={2} height={'100%'}>
      <Stack sx={{ position: 'relative', flex: 1, minHeight: 0 }}>
        <NotificationsList
          sx={{ position: 'absolute', width: '100%', height: '100%' }}
          highlightIds={searchParams.get('highlight-ids')?.split(',') || []}
        />
      </Stack>
      {/* Pätička „Nastaviť kanály" tu bola, kým bola história samostatnou
      sekciou. Dnes sú nastavenia tab hneď vedľa. */}
    </Stack>
  );
};

export default NotificationHistory;
